module.exports = __webpack_public_path__ + "img/J11754.4d27d34f.png";